import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import config from '../../../config/config';

const MOBILE_UA_REGEX = /Android|iPhone|iPad|iPod/i;
const FALLBACK_DELAY_MS = 1500;

const AppLinkRedirect = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const type = searchParams.get('type');
    const id = searchParams.get('id');
    const hash = searchParams.get('hash');
    const isArticle = type === 'article';
    const hasParams = Boolean(isArticle && id && hash);

    const fallbackPath = hasParams ? `/newsletter-article/${id}/${hash}` : '/';
    const isMobile = MOBILE_UA_REGEX.test(navigator.userAgent || '');
    let timeoutId: number | null = null;

    if (isMobile && hasParams && config.APP_DEEP_LINK_BASE) {
      const deepLink = `${config.APP_DEEP_LINK_BASE}?type=${encodeURIComponent(type || '')}&id=${encodeURIComponent(id || '')}&hash=${encodeURIComponent(hash || '')}`;
      window.location.href = deepLink;

      timeoutId = window.setTimeout(() => {
        navigate(fallbackPath, { replace: true });
      }, FALLBACK_DELAY_MS);
    } else {
      navigate(fallbackPath, { replace: true });
    }

    return () => {
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    };
  }, [navigate, searchParams]);

  return null;
};

export default AppLinkRedirect;
